import React from 'react';
import { User } from 'lucide-react';
import blogImg1 from '../assets/blog-article-1.webp';
import blogImg2 from '../assets/blog-article-2.webp';
import blogImg3 from '../assets/blog-article-3.webp';
import avatar1Img from '../assets/avatar-1.webp';
import avatar2Img from '../assets/avatar-2.webp';
import avatar3Img from '../assets/avatar-3.webp';

const BlogSection = () => {
  const blogs = [
    {
      category: 'Hearing Health',
      title: 'Dental Myths vs Facts: What You Need to Know',
      description: 'Learn the early symptoms of ear, nose, and throat issues that require timely medical attention.',
      image: blogImg1,
      author: 'Dr. Ruby Perrin',
      authorImage: avatar1Img
    },
    {
      category: 'Allergy Care',
      title: 'How Seasonal Allergies Can Affect Your Nose, Sinuses',
      description: 'A simple guide to understanding seasonal allergies and effective ways to manage them.',
      image: blogImg2,
      author: 'Daniel Scott',
      authorImage: avatar2Img
    },
    {
      category: 'Advanced Treatments',
      title: 'Reasons Your Child Frequently Gets Ear Infections',
      description: 'Learn the early symptoms of ear, nose, and throat issues that require timely medical attention.',
      image: blogImg3,
      author: 'Jacob Allen',
      authorImage: avatar3Img
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center space-x-2 bg-[#1e3a8a]/5 px-4 py-2 rounded-full mb-4">
            <div className="w-2 h-2 bg-[#22d3ee] rounded-full"></div>
            <span className="text-[#1e3a8a] text-sm font-semibold uppercase tracking-wide">Latest News</span>
          </div>
          <h2 className="text-3xl lg:text-5xl font-bold text-gray-900">
            Latest Trends & Insights
          </h2>
        </div>

        {/* Blog Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogs.map((blog, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
            >
              {/* Image */}
              <div className="relative h-56 overflow-hidden">
                <img
                  src={blog.image}
                  alt={blog.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  loading="lazy"
                  decoding="async"
                />
                <div className="absolute top-4 left-4">
                  <span className="bg-[#1e3a8a] text-white text-xs font-semibold px-3 py-1 rounded-full">
                    {blog.category}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3 leading-tight group-hover:text-[#1e3a8a] transition-colors duration-200">
                  {blog.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed mb-4">{blog.description}</p>
                
                {/* Author */}
                <div className="flex items-center space-x-3 pt-4 border-t border-gray-100">
                  <img
                    src={blog.authorImage}
                    alt={blog.author}
                    className="w-10 h-10 rounded-full object-cover"
                    loading="lazy"
                    decoding="async"
                    width="40"
                    height="40"
                  />
                  <span className="text-sm font-medium text-gray-700">{blog.author}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogSection;